/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const breakpointsTokens = {
  CoreMobile: 599,
  CoreTabletPortrait: 899,
  CoreTabletLandscape: 1199,
  CoreDesktopNormal: 1535,
  CoreDesktopLarge: 2000,
} as const;

export const colorTokens = {
  CoreBrandBlack: '#000000',
  CoreBrandWhite: '#ffffff',
  CoreBrandBlue10: '#eaf0f8',
  CoreBrandBlue20: '#dfe8f4',
  CoreBrandBlue30: '#c0d1e9',
  CoreBrandBlue40: '#8babd6',
  CoreBrandBlue50: '#4176bc',
  CoreBrandBlue60: '#2c67b5',
  CoreBrandBlue70: '#285da3',
  CoreBrandBlue80: '#235291',
  CoreBrandBlue90: '#1a3e6d',
  CoreBrandBlue100: '#122948',
  CoreBrandBrown10: '#fbf8f7',
  CoreBrandBrown20: '#f0eae1',
  CoreBrandBrown30: '#e2d5c2',
  CoreBrandBrown40: '#ccb695',
  CoreBrandBrown50: '#c5ab85',
  CoreBrandBrown60: '#b69667',
  CoreBrandBrown70: '#a4875d',
  CoreBrandBrown80: '#7f6948',
  CoreBrandBrown90: '#5b4b34',
  CoreBrandBrown100: '#493c29',
  CoreBrandLime10: '#fafdee',
  CoreBrandLime20: '#f5fcd5',
  CoreBrandLime30: '#ebfcac',
  CoreBrandLime40: '#ddfb74',
  CoreBrandLime50: '#c9ec56',
  CoreBrandLime60: '#b1d636',
  CoreBrandLime70: '#94b524',
  CoreBrandLime80: '#738c12',
  CoreBrandLime90: '#536507',
  CoreBrandLime100: '#384202',
  CoreBrandGray10: '#f4f4f4',
  CoreBrandGray20: '#ebecec',
  CoreBrandGray30: '#dedfdf',
  CoreBrandGray40: '#c4c4c4',
  CoreBrandGray50: '#a7aaaa',
  CoreBrandGray60: '#7b8080',
  CoreBrandGray70: '#656b6b',
  CoreBrandGray80: '#394040',
  CoreBrandGray90: '#232b2b',
  CoreBrandGray100: '#1c2222',
  CoreBrandOrange10: '#fcf0ee',
  CoreBrandOrange20: '#fae5de',
  CoreBrandOrange30: '#f5cabd',
  CoreBrandOrange40: '#efb09c',
  CoreBrandOrange50: '#ea957b',
  CoreBrandOrange60: '#e57b5a',
  CoreBrandOrange70: '#ce6f51',
  CoreBrandOrange80: '#b76248',
  CoreBrandOrange90: '#a0563f',
  CoreBrandOrange100: '#733e2d',
  CoreBrandRed10: '#fbe8ec',
  CoreBrandRed20: '#f8d2d8',
  CoreBrandRed30: '#f0a4b1',
  CoreBrandRed40: '#e9778a',
  CoreBrandRed50: '#e14963',
  CoreBrandRed60: '#da1c3c',
  CoreBrandRed70: '#c41936',
  CoreBrandRed80: '#ae1630',
  CoreBrandRed90: '#831124',
  CoreBrandRed100: '#570b18',
  CoreBrandGreen10: '#ebf7f6',
  CoreBrandGreen20: '#d6efec',
  CoreBrandGreen30: '#addfd9',
  CoreBrandGreen40: '#84d0c6',
  CoreBrandGreen50: '#5bc0b3',
  CoreBrandGreen60: '#32b0a0',
  CoreBrandGreen70: '#2d9e90',
  CoreBrandGreen80: '#237c70',
  CoreBrandGreen90: '#1e6a60',
  CoreBrandGreen100: '#144640',
  CoreBrandYellow10: '#fffef7',
  CoreBrandYellow20: '#fffced',
  CoreBrandYellow30: '#fef8da',
  CoreBrandYellow40: '#fcefb6',
  CoreBrandYellow50: '#fbe284',
  CoreBrandYellow60: '#f8d648',
  CoreBrandYellow70: '#ddb31f',
  CoreBrandYellow80: '#b48804',
  CoreBrandYellow90: '#825a00',
  CoreBrandYellow100: '#4d2f00',
  CoreBrandPurple10: '#f0eef9',
  CoreBrandPurple20: '#e1ddf2',
  CoreBrandPurple30: '#c3bbe5',
  CoreBrandPurple40: '#a79ad7',
  CoreBrandPurple50: '#7968b9',
  CoreBrandPurple60: '#7358b8',
  CoreBrandPurple70: '#634ba0',
  CoreBrandPurple80: '#543f88',
  CoreBrandPurple90: '#453371',
  CoreBrandPurple100: '#36285b',
  CoreBrandTurquoise10: '#f2fbfb',
  CoreBrandTurquoise20: '#e4f7f7',
  CoreBrandTurquoise30: '#c8f0f0',
  CoreBrandTurquoise40: '#abe8e8',
  CoreBrandTurquoise50: '#8cdfe1',
  CoreBrandTurquoise60: '#68d7d9',
  CoreBrandTurquoise70: '#65bbbd',
  CoreBrandTurquoise80: '#479ca0',
  CoreBrandTurquoise90: '#127375',
  CoreBrandTurquoise100: '#0a595b',
  CoreLegacyPurpleLightest: '#ebe5f5',
  CoreLegacyPurpleLight: '#aa95d1',
  CoreLegacyPurpleBase: '#7358b8',
  CoreLegacyPurpleDark: '#54398c',
  CoreLegacyPurpleDarkest: '#3e1f61',
  CoreLegacyPurpleDarkest1: '#754ea0',
  CoreLegacyPinkLightest: '#fdd5ea',
  CoreLegacyPinkLight: '#fd90c4',
  CoreLegacyPinkBase: '#ed429f',
  CoreLegacyPinkDark: '#bf2680',
  CoreLegacyPinkDarkest: '#8f0d5f',
  CoreLegacySlateLightest1: '#f3f8fc',
  CoreLegacySlateLightest2: '#edf2f7',
  CoreLegacySlateLightest3: '#e3e8ed',
  CoreLegacySlateLight1: '#c8d1da',
  CoreLegacySlateLight2: '#a3b3c4',
  CoreLegacySlateLight3: '#909ead',
  CoreLegacySlateBase: '#364453',
  CoreLegacySlateDark1: '#2b3946',
  CoreLegacySlateDark2: '#1f2a36',
  CoreLegacySlateDark3: '#131e29',
  CoreLegacyTransparent: 'rgba(0, 0, 0, 0)',
} as const;

export const elevationTokens = {
  CoreShadowOffsetX0: '0px',
  CoreShadowOffsetX1: '1px',
  CoreShadowOffsetY0: '0px',
  CoreShadowOffsetY1: '1px',
  CoreShadowOffsetY4: '4px',
  CoreShadowBlur0: '0px',
  CoreShadowBlur2: '2px',
  CoreShadowBlur5: '5px',
  CoreShadowBlur9: '9px',
  CoreShadowSpread0: '0px',
  CoreShadowSpread1: '1px',
  CoreLevel0: '0',
  CoreLevel1: '1',
  CoreLevel999: '999',
  CoreLevel1000: '1000',
  CoreLegacy5: '5',
  CoreLegacy10: '10',
  CoreLegacy12: '12',
  CoreLegacy20: '20',
  CoreLegacy25: '25',
  CoreLegacy100: '100',
  CoreLegacy1049: '1049',
  CoreLegacy1050: '1050',
  CoreLegacy1051: '1051',
  CoreLegacy1100: '1100',
  CoreLegacy2000: '2000',
  CoreLegacy9999: '9999',
} as const;

export const fontTokens = {
  CoreSize11: '11px',
  CoreSize12: '12px',
  CoreSize13: '13px',
  CoreSize14: '14px',
  CoreSize16: '16px',
  CoreSize18: '18px',
  CoreSize20: '20px',
  CoreSize24: '24px',
  CoreSize28: '28px',
  CoreSize30: '30px',
  CoreSize36: '36px',
  CoreSize48: '48px',
  CoreSize60: '60px',
  CoreSize72: '72px',
  CoreSize90: '90px',
  CoreFamilyMonospace: '"Roboto Mono", ui-monospace, Menlo, Monaco, monospace',
  CoreFamilyCursive: 'dancingscript, cursive',
  CoreFamilySansSerif: '"Inter var", "fallback for Inter", sans-serif',
  CoreFamilySerif: '"SangBleu Versailles", "fallback for SangBleu", serif',
  CoreWeightLight: '300',
  CoreWeightRegular: '400',
  CoreWeightMedium: '500',
  CoreWeightSemibold: '600',
  CoreWeightBold: '700',
  CoreFeatureSansSerifBase: '"ss01", "cv05", "cv10", "calt"',
} as const;

export const sizeTokens = {
  CoreRadiusNumerical0: '0px',
  CoreRadiusNumerical3: '3px',
  CoreRadiusNumerical4: '4px',
  CoreRadiusNumerical8: '8px',
  CoreRadiusNumerical16: '16px',
  CoreRadiusNumerical24: '24px',
  CoreRadiusNumerical42: '42px',
  CoreRadiusPercentage50: '50%',
  CoreBorder0: '0px',
  CoreBorder1: '1px',
  CoreBorder2: '2px',
  CoreBorder3: '3px',
  CoreBorder4: '4px',
  CoreBorder5: '5px',
  CoreSpacing0: '0px',
  CoreSpacing2: '2px',
  CoreSpacing4: '4px',
  CoreSpacing8: '8px',
  CoreSpacing12: '12px',
  CoreSpacing16: '16px',
  CoreSpacing20: '20px',
  CoreSpacing24: '24px',
  CoreSpacing32: '32px',
  CoreSpacing40: '40px',
  CoreSpacing48: '48px',
} as const;
